import { Alert, Box, Stack, TextField, Typography } from "@mui/material";
import CopyButton from "components/common/CopyButton";

interface Props {
  secretKey: string;
  webhookUrl?: string;
  // One-time secrets warn that the value won't be shown again; a plain reveal
  // does not.
  oneTime?: boolean;
}

function CopyableField({ label, value }: { label: string; value: string }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <TextField
        size="small"
        label={label}
        value={value}
        fullWidth
        InputProps={{
          readOnly: true,
          sx: { fontFamily: "monospace", fontSize: 13 },
        }}
      />
      <CopyButton value={value} label={`Copy ${label}`} />
    </Box>
  );
}

/**
 * Shows a webhook trigger's setup values to paste into the provider (Paycom)
 * UI: the Webhook URL (optional) and the Secret-Key. Used by the create
 * dialog / wizard success screens (one-time) and the panel's reveal/rotate
 * dialog.
 */
export default function WebhookSetupReveal({
  secretKey,
  webhookUrl,
  oneTime = false,
}: Props) {
  return (
    <Stack spacing={1.5}>
      <Typography variant="body2" color="text.secondary">
        Paste {webhookUrl ? "these values" : "this secret"} into the provider
        (Paycom) webhook UI.
      </Typography>
      {webhookUrl && <CopyableField label="Webhook URL" value={webhookUrl} />}
      <CopyableField label="Secret-Key" value={secretKey} />
      {oneTime && (
        <Alert severity="warning">
          Copy the Secret-Key now - it will not be shown again. You can rotate
          it later if it is lost.
        </Alert>
      )}
    </Stack>
  );
}
